export default __webpack_public_path__ + "static/media/js.afcba61e.png";